import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "right-wrap" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "tab-nav" }
const _hoisted_5 = { class: "leftitem" }
const _hoisted_6 = { class: "user-profile-container" }
const _hoisted_7 = { class: "RC-con-a" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "RC-con-a-list-item" }
const _hoisted_10 = { class: "RC-con-a-list-item-avatar" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "profile-content" }
const _hoisted_13 = { class: "avatar-upload" }
const _hoisted_14 = { class: "upload-tips" }

import { ref, onMounted, reactive } from "vue";
import { ElMessage } from "element-plus";

import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";

interface UserAvatarInfo {
  id: number;
  url: string;
  avatar: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  setup(__props) {

const activeTab = ref<string>("all");

const avatarlistData = ref<UserAvatarInfo[]>([]);

const userAvatar = reactive({
  selectedAvatar: 0,
  userAvatarUrl: "",
  avatarName: "",
  btnshow: true,
});

const ClickAvatar = (id: number, url: string, name: string) => {
  userAvatar.selectedAvatar = id;
  userAvatar.userAvatarUrl = url;
  userAvatar.avatarName = name;
  userAvatar.btnshow = false;
};

const SSRData = ref({
  title: "个人头像 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

onMounted(() => {
  activeTab.value = "all";
  fetchUserDefaultAvatarList();
  fetchUserInfoAvatar();
});

const fetchUserDefaultAvatarList = async () => {
  try {
    const response = await axiosInstance.post(
      "/api/UserInfo/GetUserDefaultAvatarList",
      {}
    );
    var result = response.data;
    if (result.success) {
      avatarlistData.value = result.data;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 更新头像
const updateAvatarBtn = () => {
  if (userAvatar.avatarName === "") {
    ElMessage.error("请选择头像");
    return;
  }
  var postdata = {
    avatar_url: userAvatar.avatarName,
    uuid: "100000001",
  };
  axiosInstance.post("api/UserInfo/UpdateUserAvatar", postdata).then((res) => {
    var result = res.data;
    if (result.success) {
      ElMessage.success("修改成功");
      fetchUserInfoAvatar();
      userAvatar.btnshow = true;
    } else {
      ElMessage.error(result.message);
    }
  });
};

// 获取个人头像
const fetchUserInfoAvatar = async () => {
  try {
    const response = await axiosInstance.post(
      "/api/UserInfo/UserInfoAvatar",
      {}
    );
    var result = response.data;
    if (result.success) {
      userAvatar.selectedAvatar = result.data.avatar_id;
      userAvatar.userAvatarUrl = result.data.avatar_url;
      userAvatar.avatarName = result.data.avatar_name;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "creator-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(CreatorHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreatorSidebar),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tabs, {
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "用户头像",
                          name: "all",
                          style: {"font-size":"18px"}
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 15 }, {
                        default: _withCtx(() => [
                          _cache[1] || (_cache[1] = _createElementVNode("p", null, "请选择头像", -1)),
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatarlistData.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "RC-con-a-list",
                                onClick: ($event: any) => (ClickAvatar(item.id, item.url, item.avatar)),
                                key: item.id
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("span", _hoisted_10, [
                                    _createElementVNode("img", {
                                      src: item.url,
                                      width: "64",
                                      height: "64"
                                    }, null, 8, _hoisted_11),
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["M-icon", 
                              userAvatar.selectedAvatar == item.id
                                ? 'M-icon-check'
                                : ''
                            ])
                                    }, null, 2)
                                  ])
                                ])
                              ], 8, _hoisted_8))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_el_avatar, {
                                  src: userAvatar.userAvatarUrl,
                                  size: 100
                                }, null, 8, ["src"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, {
                    gutter: 120,
                    style: {"margin-top":"120px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: updateAvatarBtn,
                            size: "large",
                            disabled: userAvatar.btnshow
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("保存修改")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})